module.exports = __webpack_public_path__ + "img/c5.3c5b02bc.png";